import fetchClient from './fetchClient';
import { errorHandler } from "./utils";


const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const createEmailCampaign = async (data: any) => {
    const res: any = await fetchClient.post("/emailing", data, config()).catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getEmailCampaigns= async () => {
    const res: any = await fetchClient.get(`/emailing`, config()).catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getEmailCampaign = async (id: string) => {
    const res: any = await fetchClient.get(`/emailing/${id}`, config()).catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const updateEmailCampaign = async (id: string, data: any) => {
	const res: any = await fetchClient
        .put(`/emailing/${id}`, data, config())
        .catch(errorHandler);
	if (!res) return null;
	return res.data;
}
